module.exports = __webpack_public_path__ + "static/media/CompetenciaImgEng.414241e8.png";